<template>
	<Doughnut :data="data" :options="options" />
</template>

<script>
import { Doughnut } from 'vue-chartjs'
import { useChart } from '@/composables/useChart'

const DoughnutChart = {
	props: ['data', 'options'],
	components: { Doughnut },
	setup () {
		useChart()
	}
}

export default DoughnutChart
export { DoughnutChart as mdbDoughnutChart }
</script>
